const isEmail = value => {
  const isValid = value && value.length > 0 && value !== ' ' && value.indexOf('@') > 0 && value.lastIndexOf('.') > value.indexOf('@')
  if (!isValid) {
    return { isValid, message: 'Please enter a valid email address.' }
  }
  return { isValid, message: '' }
}

export default isEmail
